import { signOut } from 'next-auth/react'

export const authFetch = async (url: string, options: RequestInit = {}) => {
  try {
    const response = await fetch(url, options)

    if (!response.ok) {
      await handleErrorResponse(response)
    }

    const data = await response.json()

    // Check if the response has an error field even if status is 200
    if (data && data.error) {
      console.log(`authFetch found error in data: ${data.error}`)
      throw new Error(data.error)
    }

    return data
  } catch (error) {
    console.log(`authFetch error: ${error instanceof Error ? error.message : String(error)}`)
    console.log(`authFetch error stack:`, error instanceof Error ? error.stack : 'No stack trace')
    handleError(error)
  }
}

// Handle error responses specifically
const handleErrorResponse = async (response: Response) => {
  if (response.status === 401) {
    console.log('401 detected in authFetch - signing out')
    signOut({ callbackUrl: '/login' })
    throw new Error('Authentication required. Please log in first.')
  } else if (response.status === 422) {
    console.log('Plan limit reached')
    return
  }

  // For other error statuses, extract the error message
  const contentType = response.headers.get('content-type')

  try {
    let errorMessage: string

    if (contentType && contentType.includes('application/json')) {
      const errorData = await response.json()

      console.log(`API JSON error response: ${JSON.stringify(errorData)}`)

      errorMessage = errorData?.error || errorData?.message || `Request failed with status: ${response.status}`
    } else {
      const textResponse = await response.text()

      console.log(`API text error response: ${textResponse}`)

      errorMessage = textResponse || `Request failed with status: ${response.status}`
    }

    throw new Error(errorMessage)
  } catch (parseError) {
    if (parseError instanceof Error && parseError.message.includes('Request failed with status')) {
      console.log(`Error processing response: ${parseError.message}`)
    }

    throw parseError
  }
}

const handleError = (error: unknown) => {
  //console.log(`handleError: ${error instanceof Error ? error.message : String(error)}`)
  throw error
}
